<template>
    <div class="forgetPassword">
        <div class="left"></div>
        <div class="right">
            <div class="title">重置登录密码</div>
            <div class="inputs" style="margin-bottom:16px">
                <input type="text" v-model="Username" placeholder="请输入手机号">
            </div>
            <div style="margin-bottom:16px">
                <sms-verification className="inputs verification" :phone="Username" :key-code.sync="KeyCode" :is-show-key-code="isShowKeyCode" :time="time" @sendCode="getKeyCode" />
            </div>
            <div class="inputs" style="margin-bottom:16px">
                <input type="password" v-model="Password" placeholder="请设置6至20位登录密码">
            </div>
            <div class="inputs">
                <input type="password" v-model="Password1" placeholder="请再次输入登录密码">
            </div>
            <div class="button" @click="Submission">确定</div>
            <div class="bottom">
                <span @click="$router.push('/login')">返回用户登录</span>
            </div>
        </div>
    </div>
</template>

<script>
import SmsVerification from '@/components/SmsVerification';
import { generateSmsCode } from '@/utils/security';

export default {
    name: "forgetPassword",
    components: {
        SmsVerification
    },
    data() {
        return {
            Username: '',
            KeyCode: '',
            Password: '',
            Password1: '',
            warning4: '',
            isclick: false,
            time: 60,
            isShowKeyCode: true
        }
    },
    watch: {
        Username() {
            this.panduan();
        },
        KeyCode() {
            this.panduan();
        },
        Password() {
            this.panduan();
        },
        Password1() {
            this.panduan();
        }
    },
    methods: {
        /**
         * 提交表单，重置密码
         */
        Submission() {
            var OEMdomain = this.$OEMdomain;
            var phone = this.Username;
            var code = this.KeyCode;
            var passwordOne = this.Password;
            var passwordTwo = this.Password1;
            var _this = this;
            var num1 = this.Username;
            var reg = /^1[123456789]\d{9}$/;
            var num2 = this.KeyCode;
            var reg3 = /[a-zA-z0-9!@#$%^&*.?]{6,20}/
            var num3 = this.Password;
            var num4 = this.Password1;

            // 验证手机号
            if (!num1) {
                this.warning4 = '手机号码不能为空';
                this.$message({
                    message: '手机号码不能为空',
                    type: 'error'
                });
                return;
            }
            if (!reg.test(num1)) {
                this.warning4 = '账号或密码不正确';
                this.$message({
                    message: '账号或密码不正确',
                    type: 'error'
                });
                return;
            }

            // 验证验证码
            if (!num2) {
                this.warning4 = '验证码不能为空';
                this.$message({
                    message: '验证码不能为空',
                    type: 'error'
                });
                return;
            }

            // 验证密码
            if (!num3) {
                this.warning4 = '密码不能为空';
                this.$message({
                    message: '密码不能为空',
                    type: 'error'
                });
                return;
            }
            if (!reg3.test(num3)) {
                this.warning4 = '密码不能少于6位字符，不能超过20位字符';
                this.$message({
                    message: '密码不能少于6位字符，不能超过20位字符',
                    type: 'error'
                });
                return;
            }

            // 验证两次密码是否一致
            if (num3 !== num4) {
                this.warning4 = '两次输入的密码不一致';
                this.$message({
                    message: '两次输入的密码不一致',
                    type: 'error'
                });
                return;
            }

            // 检查是否可以提交
            if (!this.isclick) {
                return;
            }

            // 调用API重置密码
            this.$ajax.post(this.G_uri + this.ports.user.forgotPassword, {
                phone: phone,
                code: code,
                passwordOne: passwordOne,
                passwordTwo: passwordTwo,
                webSite: OEMdomain
            }).then(function (res) {
                if (res.data.code == 2000) {
                    _this.$message.success("密码重置成功，请登录")
                    _this.$router.push('/login')
                } else {
                    _this.warning4 = res.data.msg;
                    _this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                console.log(error);
            });
        },

        /**
         * 判断表单是否填写完整
         */
        panduan() {
            var num1 = this.Username;
            var num2 = this.KeyCode;
            var num3 = this.Password;
            var num4 = this.Password1;
            if (num1 && num2 && num3 && num4) {
                this.isclick = true;
            } else {
                this.isclick = false;
            }
        },

        /**
         * 验证码倒计时
         */
        timers() {
            var _this = this;
            var timer = setInterval(function () {
                _this.time--;
                if (_this.time == 0) {
                    clearInterval(timer)
                    _this.isShowKeyCode = true;
                    _this.time = 60;
                }
            }, 1000)
        },

        /**
         * 发送验证码
         */
        getKeyCode() {
            console.log('调用了')
            var OEMdomain = this.$OEMdomain;
            var phone = this.Username;
            var reg = /(^1[123456789]\d{9}$)|(^\d{8}$)/;
            var _this = this;

            // 验证手机号格式
            if (!reg.test(phone)) {
                this.warning4 = '请输入正确的手机号';
                _this.$message({
                    message: '请输入正确的手机号',
                    type: 'error'
                });
                return;
            } else {
                this.warning4 = "";
            }
            console.log('yanzhengchenggong  zoujinlaile  xiayibuqingqiujiekou')

            // 调用API发送验证码
            const { timestamp, code } = generateSmsCode();
            this.$ajax.post(this.G_uri + this.ports.user.forgetPasswordPhone, {
                phone: phone,
                webSite: OEMdomain,
                code: code,
                timestamp: timestamp
            }).then(function (res) {
                if (res.data.code == 2000) {
                    _this.isShowKeyCode = false;
                    _this.timers();
                } else {
                    _this.warning4 = res.data.msg;
                    _this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });
                }
            }).catch(function (error) {
                console.log(error)
            });
        }
    }
}
</script>

<style scoped lang="less">
* {
    box-sizing: border-box;
}

.forgetPassword {
    width: 1146px;
    height: 595px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 13px;

    .left {
        background: url(/imgs/user/login_left_01.png) no-repeat;
        width: 606px;
        height: 100%;
        float: left;
        background-size: 100%;
        background-position: -3px -3px;
    }

    .right {
        width: 534px;
        float: right;
        font-size: 15px;
    }

    .title {
        line-height: 28px;
        color: #333333;
        font-size: 20px;
        text-align: center;
        margin: 90px auto 50px;
        font-weight: bold;
    }

    .inputs {
        width: 80%;
        height: 44px;
        display: block;
        margin: 0 auto;
        line-height: 42px;
        color: #7C7C7C;
        position: relative;
        background: rgba(36, 130, 243, 0.1);
        border-radius: 4px;
        border: 1px solid rgba(25, 122, 239, 0.3);

        &>img {
            position: relative;
            top: -1px;
        }

        input {
            border: none;
            height: 42px;
            width: 312px;
            line-height: 52px;
            display: inline-block;
            background: none;
            border-radius: 4px;
            outline: none;
            text-indent: 24px;
        }

        input:-webkit-autofill {
            -webkit-box-shadow: none !important;
        }

        /deep/input:-internal-autofill-selected {
            appearance: menulist-button;
            background: none !important;
            background-image: none !important;
            color: #7C7C7C !important;
        }
    }

    .inputs.verification {
        background: none;
        border: none;
        border-radius: 0px;

        >input {
            background: rgba(36, 130, 243, 0.1);
            border-radius: 4px;
            border: 1px solid rgba(25, 122, 239, 0.3);
        }
    }

    .warning4 {
        text-align: center;
        color: red;
        line-height: 40px;
        height: 40px;
    }

    .button {
        width: 407px;
        height: 56px;
        background: #3D90F6;
        border-radius: 28px;
        margin: 0 auto;
        font-size: 16px;
        line-height: 56px;
        text-align: center;
        color: #fff;
        cursor: pointer;
        margin-top: 20px;
    }

    .bottom {
        margin: 20px auto;
        width: 407px;
        font-size: 13px;
        text-align: center;

        span {
            color: #3D90F6;
            cursor: pointer;
        }
    }
}
</style>
